import Box from '@mui/material/Box';

/** Inline button spinner from the design (16px, 2px ring, open right side). */
export function Spinner({ size = 16, label }: { size?: number; label?: string }) {
  // Decorative next to a button label; pass a translated `label` when it is the only status cue.
  return (
    <Box
      component="span"
      {...(label ? { role: 'progressbar', 'aria-label': label } : { 'aria-hidden': true })}
      sx={{
        width: size,
        height: size,
        border: '2px solid currentColor',
        borderRightColor: 'transparent',
        borderRadius: '50%',
        display: 'inline-block',
        boxSizing: 'border-box',
        animation: 'spin .8s linear infinite',
        flexShrink: 0,
      }}
    />
  );
}
